import type { SetsKey } from './keys';

export const ro: Partial<Record<SetsKey, string>> = {
  'app.title': 'Mulțimi',
  'app.eyebrow': 'Matematică · Mulțimi',
  'app.tagline': 'Experimente interactive de teoria mulțimilor',
  'app.panel.heading': 'Parametri',
  'btn.advanced': 'Avansat',
  'btn.reset': 'Reinițializează',
  'btn.randomise': 'Aleatoriu',
};
